import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function Breadcrumb({ arr }) {
  return (
    <div className="container pt-5">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {arr.map((i, ind) =>
            ind < arr.length - 1 ? (
              <li className="breadcrumb-item" key={ind}>
                <AniLink paintDrip hex="#551864" to={i.path}>
                  {i.name}
                </AniLink>
              </li>
            ) : (
              <li
                className="breadcrumb-item active"
                aria-current="page"
                key={ind}
              >
                {i.name}
              </li>
            )
          )}
        </ol>
      </nav>
    </div>
  )
}

export default Breadcrumb
